var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "a",
      {
        staticClass:
          "btn-google btn-block p-0 d-flex align-items-center justify-content-center border rounded fg-normal fg-normal-hover btn-lg",
        attrs: {
          id: "signInGoogleButton",
          "data-user-modal-link-social-authenticate-google": "",
          href: "#",
          title: _vm.googleTitle,
        },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.startSocialFlow("google")
          },
        },
      },
      [
        _c("img", { attrs: { src: _vm.googleIcon, alt: "Google Icon" } }),
        _vm._v(" "),
        _c("span", { staticClass: "ml-1" }, [_vm._v(_vm._s(_vm.googleText))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass:
          "btn-apple btn-block p-2 d-flex align-items-center justify-content-center border rounded fg-normal fg-normal-hover btn-lg",
        staticStyle: { height: "42.25px" },
        attrs: {
          "data-user-modal-link-social-authenticate-apple": "",
          href: "#",
          title: _vm.appleTitle,
        },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.startSocialFlow("apple")
          },
        },
      },
      [
        _c("img", { attrs: { src: _vm.appleIcon, alt: "Apple Icon" } }),
        _vm._v(" "),
        _c("span", { staticClass: "ml-1" }, [_vm._v(_vm._s(_vm.appleText))]),
      ]
    ),
    _vm._v(" "),
    true === false
      ? _c(
          "a",
          {
            staticClass:
              "btn-facebook btn-block mt-3 p-2 d-flex align-items-center justify-content-center border fg-white fg-white-hover btn-lg",
            attrs: {
              "data-user-modal-link-social-authenticate-facebook": "",
              href: "#",
              title: _vm.facebookTitle,
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.startSocialFlow("facebook")
              },
            },
          },
          [
            _c("i", {
              staticClass: "fab fa-facebook font-size-125 lh-inherit",
            }),
            _vm._v(" "),
            _c("span", { staticClass: "ml-1 lh-1" }, [
              _vm._v(_vm._s(_vm.facebookText)),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }